App.namespace('components.locale_auto_set', () => {
  const localeManager = App.components.locale_manager;


  const setLocale = () => {
    localeManager.setLocale(window.__TGV_ISO_COUNTRY_CODE);
  };

  const pageHasValidCountryCode = () => {
    return window.__TGV_ISO_COUNTRY_CODE
      && window.__TGV_COUNTRIES_CODES
      && window.__TGV_COUNTRIES_CODES.indexOf(window.__TGV_ISO_COUNTRY_CODE) !== -1;
  };

  if (pageHasValidCountryCode()) {
    window.addEventListener('load', setLocale);
  }
});
